import Rooms from '../ui/Rooms';
import { connect } from 'react-redux';
import {
  hostProfileSubmit,
  roomsSubmit,
  roomFormSubmit,
  skipSubmit,
  goBack,
  invalidateRooms,
  fetchRoomsIfNeeded,
  photoFormSubmit
 } from '../../actions';

const mapStateToProps = (state, props) => {
  const numRooms = (state, name) => state.localProfileElements.elements.home[name]

  return ({
    page: state.page,
    intl: props.intl,
    user: state.user,
    content: state.content,
    beddingOptions: state.territory.bed_types,
    profileElements: state.profileElements,
    activeProfileElements: state.activeProfileElements,
    numBedrooms: numRooms(state, 'num_bedrooms_selections'),
    numBathrooms: numRooms(state, 'num_bathrooms_selections'),
    numBedroomsForGuests: numRooms(state, 'num_bedrooms_for_guests_selections'),
    rooms: state.rooms,
    requiredFields: state.requiredFields,
    territory: state.territory,
    uploader: state.uploader
  })
}

const mapDispatchToProps = dispatch =>
  ({
    onHostProfileSubmit(payload) {
      dispatch(
        hostProfileSubmit(payload)
      );
    },
    onRoomsSubmit(payload) {
       dispatch(
         roomsSubmit(payload)
       );
    },
    onPhotoFormSubmit(payload) {
      dispatch(invalidateRooms())
      dispatch(
        photoFormSubmit(payload)
      )
    },
    onPhotoDestroySubmit(payload) {
      dispatch(invalidateRooms())
      dispatch(
        photoFormSubmit(payload)
      )
    },
    onRoomFormSubmit(payload) {
       dispatch(invalidateRooms());
       dispatch(
         roomFormSubmit(payload)
       );
    },
    onSkipSubmit(payload) {
       dispatch(
         skipSubmit(payload)
       );
    },
    onGoBack(payload) {
       dispatch(
         goBack(payload)
       );
    },
    onFetchRoomsIfNeeded(payload) {
      dispatch(fetchRoomsIfNeeded());
    },
    onRoomsRefresh(payload) {
      dispatch(invalidateRooms());
      dispatch(fetchRoomsIfNeeded());
    }
  });

const Container = connect(mapStateToProps, mapDispatchToProps)(Rooms);

export default Container;
